/**
 * @fileoverview The one thing the app still does to a piece of advice's
 * words: put the moment's own in. Which advice shows, for whom and how often
 * is the server's (the to-do rebuild, batch 5); it sends the words with the
 * gardener's name and the owner's already in, and leaves {plant} and
 * {location} for the screen that knows the plant just added or photographed.
 *
 * Where: TipsContext (words).
 * API: none.
 *
 * @module tips/rules
 */

/**
 * Puts the moment's words in: {plant}, {location} (and any other the screen
 * gives). A word that is not known is left out, along with a comma it leaves
 * hanging.
 *
 * @param text - The words with their placeholders.
 * @param words - Each placeholder's words, by its name.
 * @returns The words filled in.
 */
export function fill(text: string, words: Record<string, string | null | undefined>): string {
  return text
    .replace(/\{(\w+)\}/g, (_, key: string) => words[key] ?? '')
    .replace(/,\s*$/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
